import { render } from "./TvmPageRedirectComponent.vue?vue&type=template&id=7c6e338c"
import script from "./TvmPageRedirectComponent.vue?vue&type=script&lang=js"
export * from "./TvmPageRedirectComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/TvmPageRedirectComponent/TvmPageRedirectComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c6e338c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c6e338c', __exports__)) {
    api.reload('7c6e338c', __exports__)
  }
  
  module.hot.accept("./TvmPageRedirectComponent.vue?vue&type=template&id=7c6e338c", () => {
    api.rerender('7c6e338c', render)
  })

}


export default __exports__